var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8168 43.68V36.128C23.8114 35.936 22.1048 35.456 20.6968 34.688C19.3101 33.8987 18.2434 32.8747 17.4968 31.616C16.7714 30.336 16.4088 28.8853 16.4088 27.264C16.4088 25.6 16.7394 24.128 17.4008 22.848C18.0834 21.568 19.1181 20.544 20.5048 19.776C21.9128 19.008 23.6834 18.56 25.8168 18.432V11.68H30.2328V18.432C32.2594 18.6027 33.9661 19.0827 35.3528 19.872C36.7394 20.64 37.7848 21.6533 38.4888 22.912C39.2141 24.1707 39.5768 25.6213 39.5768 27.264C39.5768 28.8853 39.2248 30.336 38.5208 31.616C37.8381 32.896 36.8034 33.9307 35.4168 34.72C34.0514 35.488 32.3234 35.9573 30.2328 36.128V43.68H25.8168ZM25.8168 32.672V21.856C24.8994 21.984 24.0994 22.2933 23.4167 22.784C22.7341 23.2533 22.2114 23.872 21.8488 24.64C21.4861 25.408 21.3048 26.2827 21.3048 27.264C21.3048 28.2667 21.4754 29.152 21.8168 29.92C22.1794 30.688 22.6914 31.3067 23.3528 31.776C24.0354 32.2453 24.8568 32.544 25.8168 32.672ZM30.2328 32.672C31.1928 32.544 32.0034 32.2453 32.6648 31.776C33.3261 31.3067 33.8274 30.688 34.1688 29.92C34.5101 29.152 34.6808 28.2667 34.6808 27.264C34.6808 25.792 34.2861 24.576 33.4968 23.616C32.7074 22.656 31.6194 22.0907 30.2328 21.92V32.672Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilIcon);
export default __webpack_public_path__ + "static/media/philIcon.78543b677441f5668cbd8fd1f246fad7.svg";
export { ForwardRef as ReactComponent };